import UnusedBankAccountsCard from './UnusedBankAccountsCard'

export default UnusedBankAccountsCard
